export default function Legend() {
  return (
    <div className="template-schedule-legend ml-5 mb-3">
      <span className="template-schedule-legend-title">Legend:</span>
      <span>
        <strong>7</strong> = 7am - 5pm
      </span>
      <span>
        <strong>CM</strong> = 8am - 3pm Clinical Microscopy
      </span>
      <span>
        <strong>HM</strong> = 8am - 3pm Hematology
      </span>
      <span>
        <strong>SR</strong> = 8am - 3pm Serology
      </span>
    </div>
  );
}
